import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationReportingService {
  apiUrl = environment.url;
  editReportSetting = new Subject<any>();
  editReportSettingData$ = this.editReportSetting.asObservable();

  constructor(private http: HttpClient) {}

  getOrgReportSetting(reportType?: any, reportFormatId?: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/OrganizationReportSetting/GetAllOrganizationReportScope?projectReportSettingId=${reportType}&reportType=${reportFormatId}`
      )
      .toPromise();
  }

  refreshReportSetting() {
    this.editReportSetting.next(() => {});
  }

  getUploadSKUList() {
    return this.http.get<any>(`${this.apiUrl}/SKUData/GetAllSKUDataList`);
  }

  getAddEditSKUData(id: any) {
    return this.http.get<any>(`${this.apiUrl}/SKUData/GetSKUDataForAddUpdate?id=${id}`).toPromise();
  }
  getSKUCategoryWithoutDepartment() {
    return this.http.get<any>(`${this.apiUrl}/SKUData/GetSKUCategoryWithoutDepartment`).toPromise();
  }

  addUpdateSKUData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/SKUData/AddUpdateSKUData`, payload);
  }

  deleteSKUData(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/SKUData/DeleteSKUData?id=${id}`);
  }

  getAllSKUDataList() {
    return this.http.get<any>(`${this.apiUrl}/SKUData/GetAllSKUDataList`).toPromise();
  }

  getScenarioSKUData(scenarioId: any, productId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/SKUData/GetSKUData?scenarioId=${scenarioId}&productId=${productId}`)
      .toPromise();
  }

  addUpdateOrganizationSKUCategory(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/SKUData/AddOrganizationSKUCategory`, payload);
  }

  exportSKUData(isExportOnlyCompleted: any) {
    return this.http.get<any>(
      `${this.apiUrl}/SKUData/ExportSKUData?isExportOnlyCompleted=${isExportOnlyCompleted}`
    );
  }

  getSkuDepartments() {
    return this.http.get<any>(`${this.apiUrl}/SKUData/GetSKUDepartmentsList`).toPromise();
  }
  getSKUCategoryList() {
    return this.http.get<any>(`${this.apiUrl}/SKUData/GetSKUCategoryList`).toPromise();
  }
  getSKUSubCategoryList() {
    return this.http.get<any>(`${this.apiUrl}/SKUData/GetSKUSubCategoryList`).toPromise();
  }

  getSkuCategoryDepartmentId(deptId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/SKUData/GetSKUCategoryByDepartmentId?departmentId=${deptId}`)
      .toPromise();
  }

  getSkuSubCategoryCategoryId(categoryId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/SKUData/GetSKUSubCategoryByCategoryId?categoryId=${categoryId}`)
      .toPromise();
  }

  deleteProjectSavingLogs(projectId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProjectSavingLog/DeleteProjectSavingLog?projectId=${projectId}`
    );
  }

  getScenarioBasedOnProdId(productId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/SKUData/GetScenarioBasedOnProduct?productId=${productId}`
    );
  }

  getAllInternalDataProductCategoriesList() {
    return this.http
      .get<any>(`${this.apiUrl}/SKUData/GetAllInternalDataProductCategoriesList`)
      .toPromise();
  }
}
